import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { NAV_LINKS, FIRM } from '../data/siteData';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openSub, setOpenSub] = useState(null);
  const location = useLocation();

  const toggleSub = (label) => setOpenSub(openSub === label ? null : label);
  return (
    <nav className="bg-white border-b-[3px] border-gold sticky top-0 z-[200] shadow-md">
     {/* Navbar height badli */}
<div className="flex items-center justify-between px-[5%] h-[90px]">

  {/* Logo - Maximum size increase */}
  <Link to="/" className="flex items-center gap-3 no-underline h-full">
    <img 
      src={FIRM.logo} 
      alt="Company Logo" 
      className="object-contain w-auto h-full max-h-[90px]"
    />
  </Link>

        {/* Desktop Menu */}
        <ul className="hidden lg:flex items-center h-full list-none gap-4 ml-9">
          {NAV_LINKS.map((link) => (
            <li key={link.label} className="nav-item relative h-full flex items-center">
              {link.cta ? (
               <Link to={link.path} className="btn-red ml-2 text-[0.78rem] whitespace-nowrap">
                {link.label}
               </Link>
              ) : link.children ? (
                <>
                 <button className={`px-3 py-0 text-[0.80rem] font-medium uppercase tracking-wider h-full flex items-center gap-1 border-b-[3px] -mb-[3px] transition-colors whitespace-nowrap
                  ${location.pathname.startsWith(link.children[0].path.split('/').slice(0,2).join('/'))
                   ? 'text-gold border-gold' : 'text-gray-700 border-transparent hover:text-gold hover:border-gold'}`}>
                    {link.label} <span className="text-[0.55rem]">▾</span>
                 </button>
                  <div className="nav-dropdown">
                    {link.children.map(child => (
                      <Link key={child.path} to={child.path}
                        className={`block px-5 py-3 text-[0.8rem] border-b border-gray-100 transition-all
                          hover:bg-cream hover:text-gold hover:pl-7
                          ${location.pathname === child.path ? 'bg-cream text-gold pl-7' : 'text-gray-700'}
                        `}>
                        <span className="text-gold mr-2">›</span>{child.label}
                      </Link>
                    ))}
                  </div>
                </>
              ) : (
              <Link to={link.path}
              className={`px-3 py-0 text-[0.80rem] font-medium uppercase tracking-wider h-full flex items-center border-b-[3px] -mb-[3px] transition-colors whitespace-nowrap
             ${location.pathname === link.path? 'text-gold border-gold' : 'text-gray-700 border-transparent hover:text-gold hover:border-gold'}`}>{link.label}
              </Link>
              )}
            </li>
          ))}
        </ul>

        {/* Hamburger */}
        <button className="lg:hidden flex flex-col gap-1.5 p-2" onClick={() => setMobileOpen(!mobileOpen)}>
          <span className={`block w-6 h-0.5 bg-navy transition-all ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-navy transition-all ${mobileOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-navy transition-all ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-navy fixed inset-0 z-[500] overflow-y-auto p-8 pt-16">
          <button className="absolute top-5 right-5 text-white text-2xl" onClick={() => setMobileOpen(false)}>✕</button>
          <ul className="list-none mt-4">
            {NAV_LINKS.map(link => (
              <li key={link.label} className="border-b border-white/10">
                {link.children ? (
                  <>
                    <button onClick={() => toggleSub(link.label)}
                      className="w-full text-left py-4 text-white font-medium text-base flex justify-between">
                      {link.label} <span>{openSub === link.label ? '▲' : '▼'}</span>
                    </button>
                    {openSub === link.label && (
                      <ul className="pl-4 list-none pb-2">
                        {link.children.map(child => (
                          <li key={child.path}>
                            <Link to={child.path}
                              onClick={() => setMobileOpen(false)}
                              className="block py-2.5 text-white/60 text-sm border-b border-white/5 hover:text-gold-light">
                              › {child.label}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <Link to={link.path}
                    onClick={() => setMobileOpen(false)}
                    className="block py-4 text-white font-medium text-base hover:text-gold-light">
                    {link.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
}